import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {Validators, FormGroup, FormControl} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {Location, DatePipe} from '@angular/common';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import {SpinnerService} from 'src/app/services/spinner/spinner.service';
import {ToastService} from 'src/app/services/notification/toast.service';
import {WebService} from 'src/app/services/web/web.service';
import {AppConfirmService} from "../../app-confirm/app-confirm.service";
import { CreditCardHelperService } from '../../services/credit-card-helper.service';
import { PlanType } from '../../shared/enums/plan-type';
import {TranslateService} from '@ngx-translate/core';
import {of} from 'rxjs';
import {catchError, finalize} from 'rxjs/operators';
import {InvoiceReactivationService, ReactivableInvoice, ReactivationConflictCode} from './invoice-reactivation.service';
import {UserPermissionsService} from '../../services/user-permissions.service';

/** BILL-3747: permiso requerido para reactivar el cobro de una suscripción. */
const REACTIVATE_BILLING_PERMISSION = 'controllers.Invoices.reactivateBilling';

@Component({
    selector: 'app-customer-plan-update',
    templateUrl: './customer-plan-update.component.html',
    styleUrls: ['./customer-plan-update.component.scss'],
    providers: [AppConfirmService, DatePipe],
    standalone: false
})
export class CustomerPlanUpdateComponent implements OnInit {

    @ViewChild('skipBillingDialog') skipBillingDialog: TemplateRef<any>;
    @ViewChild('blockingInvoicesDialog') blockingInvoicesDialog: TemplateRef<any>;
    @ViewChild('changePlanConfirmDialog') changePlanConfirmDialog: TemplateRef<any>;
    @ViewChild('reactivateBillingDialog') reactivateBillingDialog: TemplateRef<any>;

    // ESTO ES GENERAL
    formData = {};
    console = console;
    form: FormGroup;

    // BILL-2569: tipos de plan + lógica VARIABLE
    PlanType = PlanType;
    currentPlanType: number | null = null;
    selectedPlanType: number | null = null;
    showVariableFields: boolean = false;

    get isOnDemandPlan(): boolean {
        return this.currentPlanType === PlanType.ON_DEMAND;
    }
    blockingInvoices: any[] = [];

    customer: any;
    tarjetas: any[] = new Array;
    lastarjetasa: any[] = new Array;
    previousNextBillDate: any;
    previousEndDate: any; // Store original end date for comparison
    hasInvoiceForCharge: boolean = false;
    hasOpenInvoices: boolean = false;

    public chp: any;
    public formattedCreatedAt: string = '';
    estatus: any[] = [];
    availableStatuses: any[] = []; // Estatus disponibles para el dropdown
    currentStatusDescription: string = ''; // Descripción del estatus actual cuando está deshabilitado
    isStatusEditable: boolean = false; // Controla si el campo es editable
    next: any[] = [
        {value: true, description: "SI"},
        {value: false, description: 'NO'}
    ];
    plan: any;
    servicePlans: any[] = [];
    service: any;
    initialStatus: any;
    changePlan: Boolean = false;

    // BILL-3676: reactivación de cobro
    reactivableInvoice: ReactivableInvoice | null = null;
    reactivationDone: ReactivableInvoice | null = null;
    isReactivating: boolean = false;
    private reactivateDialogRef: MatDialogRef<any> | null = null;
    private readonly INACTIVE_STATUS = 2;
    private readonly PENDING_FUTURE_STATUSES = [6, 7];

    constructor(
        private location: Location,
        private spinner: SpinnerService,
        private activatedRoute: ActivatedRoute,
        private toast: ToastService,
        private confirmService: AppConfirmService,
        private webService: WebService,
        private dialog: MatDialog,
        private datePipe: DatePipe,
        private creditCardHelper: CreditCardHelperService,
        private invoiceReactivation: InvoiceReactivationService,
        private translate: TranslateService,
        private userPermissionsService: UserPermissionsService
    ) {
        this.form = new FormGroup({
            id: new FormControl('', [
                Validators.required
            ]),
            contractNumber_Plan: new FormControl(''),
            startdate_customerPlan: new FormControl('', [
                Validators.required
            ]),
            endDate_customerPlan: new FormControl(''),
            idPlanEnrollmentrenewalPartner: new FormControl(''),
            status_customerPlan: new FormControl('', [
                Validators.required
            ]),
            nextBill: new FormControl('', [
                Validators.required
            ]),
            plan: new FormControl(''),
            service: new FormControl(''),
            tdc: new FormControl(''),
            next_bill_date: new FormControl(''),
            // BILL-2569: campos custom de planes VARIABLE — sin validators por defecto;
            // se activan dinámicamente en ngOnInit / onPlanChange según el tipo de plan.
            customAmount: new FormControl(''),
            customTaxRate: new FormControl('')
        });
    }

    ngOnInit(): void {
        this.spinner.open();
        this.loadStatuses().then(() => {
            this.activatedRoute.params.subscribe(params => {

                this.webService.get(this.webService.HOST + "/hasplan/" + params["plan"]).subscribe(chp => {

                    this.hasInvoiceForCharge = chp.hasInvoiceForCharge;
                    this.hasOpenInvoices = chp.hasOpenInvoices;
                    this.chp = chp.result;
                    this.customer = this.chp.customer;
                    this.plan = this.chp.plan.id;
                    this.service = this.chp.plan.service.id;

                    this.loadReactivableInvoice();

                    this.webService.get(this.webService.HOST + "/ecommerce/plan/service/" + this.service).subscribe(plans => {
                        this.form.controls["plan"].setValue(this.chp.plan.id);
                        this.servicePlans = (plans.result || []).filter((p: any) => +p.type !== PlanType.ON_DEMAND);

                        // BILL-2569: configurar lógica de planes VARIABLE / LINK_DE_PAGO
                        this.currentPlanType = this.chp.plan?.type;
                        this.selectedPlanType = this.currentPlanType;
                        this.applyPlanTypeRules();
                        // Se carga la información del plan asociado al cliente a través de los componentes
                        if (this.chp.lastOkBillingDate != null) this.chp.lastOkBillingDate = this.chp.lastOkBillingDate;
                        if (this.chp.lastNokBillingDate != null) this.chp.lastNokBillingDate = this.chp.lastNokBillingDate;
                        this.form.controls["contractNumber_Plan"].setValue(this.chp.contractNumber_Plan);
                        this.form.controls["id"].setValue(this.chp.id);
                        this.form.controls["startdate_customerPlan"].setValue(this.chp['startdate_customerPlan']);
                        
                        // Format createdAt to show only date (yyyy-MM-dd)
                        if (this.chp.createdAt) {
                            this.formattedCreatedAt = this.chp.createdAt.split(' ')[0];
                        }
                        
                        // Handle endDate_customerPlan conversion to Date object for matDatepicker
                        const endDateStr = this.chp.endDate_customerPlan;
                        if (endDateStr != null) {
                            const endDateParts = endDateStr.split('-'); // '2025-06-20' → ['2025', '06', '20']
                            const endDate = new Date(Number(endDateParts[0]), Number(endDateParts[1]) - 1, Number(endDateParts[2]));
                            endDate.setHours(12, 0, 0, 0); // previene desajuste UTC
                            this.form.controls["endDate_customerPlan"].setValue(endDate);
                        } else {
                            this.form.controls["endDate_customerPlan"].setValue(this.chp.endDate_customerPlan);
                        }
                        
                        this.form.controls["nextBill"].setValue(this.next[1].value);

                        const dateStr = this.chp.next_bill_date;
                        if (dateStr != null) {
                            const parts = dateStr.split('-'); // '2025-06-20' → ['2025', '06', '20']
                            const date = new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
                            date.setHours(12, 0, 0, 0); // previene desajuste UTC
                            this.form.controls["next_bill_date"].setValue(date);
                        } else {
                            this.form.controls["next_bill_date"].setValue(this.chp.next_bill_date);
                        }


                        this.previousNextBillDate = this.chp.next_bill_date;
                        this.previousEndDate = this.chp.endDate_customerPlan; // Store original end date for comparison
                        if (this.chp.idPlanEnrollmentrenewalPartner != null) {
                            this.form.controls["idPlanEnrollmentrenewalPartner"].setValue(this.chp.idPlanEnrollmentrenewalPartner);
                        }

                        // Se selecciona el estado actual del plan asociado al cliente
                        this.form.controls["status_customerPlan"].setValue(this.chp.status_customerPlan);
                        this.initialStatus = this.chp.status_customerPlan;

                        // Configurar el comportamiento dinámico del campo de estatus
                        this.configureStatusField();

                        // Siempre cargar las tarjetas válidas del customer
                        this.creditCardHelper.getValidCustomerCards(this.customer.id).subscribe(
                            (tarjetasValidas) => {
                                this.lastarjetasa = tarjetasValidas;
                                this.tarjetas = tarjetasValidas;
                                
                                // Si el plan tiene una tarjeta asociada, pre-seleccionarla
                                if (this.chp.creditCardToken && this.chp.creditCardToken.id) {
                                    const asociada = tarjetasValidas.find(t => t.id == this.chp.creditCardToken.id);
                                    if (asociada) {
                                        this.form.controls["tdc"].setValue(asociada.id);
                                    }
                                }
                                this.spinner.close();
                            },
                            err => {
                                this.spinner.close();
                            }
                        );

                    }, err => {
                        this.toast.showError(err);
                        console.log(err);
                    });
                });
            });
        }).catch(err => {
            this.toast.showError("No se pudieron cargar los estados del plan.");
            this.spinner.close();
        });
    }

    async loadStatuses(): Promise<void> {
        // Puedes cambiar el valor "1" por el tipo que corresponda si es variable
        const url = this.webService.HOST + "/hasplan/customer-plan-status/type/1";
        try {
            const response: any = await this.webService.get(url).toPromise();
            if (response && response.result) {
                this.estatus = response.result.map((item: any) => ({
                    value: item.value,
                    description: item.description
                }));
            }
        } catch (error) {
            this.estatus = [];
            throw error;
        }
    }

    /**
     * Configura el comportamiento dinámico del campo de estatus
     * Solo permite transiciones específicas:
     * - Para planes normales:
     *   - Activo (1) → Inactivo (2) o Congelado (3)
     *   - Inactivo (2) → Activo (1) o Congelado (3)
     *   - Congelado (3) → Activo (1) o Inactivo (2)
     * - Para planes por cuotas:
     *   - Solo Activo (1) o Congelado (3) → Inactivo (2)
     *   - Otros estatus solo se muestran como información
     * - BILL-2745:
     *   - Pendiente futuro (6, 7) → Inactivo (2)
     */
    configureStatusField(): void {
        const currentStatus = this.chp.status_customerPlan;

        // Obtener la descripción del estatus actual
        const currentStatusObj = this.estatus.find(status => status.value === currentStatus);
        this.currentStatusDescription = currentStatusObj ? currentStatusObj.description : 'Estado desconocido';

        if (this.canDeactivateFuturePendingSubscription(currentStatus)) {
            this.isStatusEditable = true;
            this.availableStatuses = this.estatus.filter(status => status.value === this.INACTIVE_STATUS);
            this.form.controls['status_customerPlan'].enable();
            this.form.controls['status_customerPlan'].setValue(currentStatus);
            return;
        }

        // Verificar si es un plan por cuotas
        const isInstallmentPlan = this.chp.plan?.qty_installments_to_collect_plan != null && 
                                  this.chp.plan.qty_installments_to_collect_plan !== 0;

        if (isInstallmentPlan) {
            // Para planes por cuotas: solo permitir Activo (1) o Congelado (3) → Inactivo (2)
            if (currentStatus === 1 || currentStatus === 3) {
                this.isStatusEditable = true;
                this.availableStatuses = this.estatus.filter(status => status.value === this.INACTIVE_STATUS); // Solo Inactivo
                this.form.controls['status_customerPlan'].enable();
                this.form.controls['status_customerPlan'].setValue(currentStatus);
            } else {
                // Para cualquier otro estatus en planes por cuotas, solo mostrar información
                this.isStatusEditable = false;
                this.form.controls['status_customerPlan'].disable();
                this.availableStatuses = [];
            }
        } else {
            // Planes no-cuota (incluye NORMAL y VARIABLE).
            // Verificar si el estatus actual permite edición (1, 2, 3)
            this.isStatusEditable = currentStatus === 1 || currentStatus === 2 || currentStatus === 3;

            if (this.isStatusEditable) {
                // Determinar qué estatus están disponibles para transición según el estatus actual
                let allowedTransitionValues: number[] = [];
                
                switch (currentStatus) {
                    case 1: // Activo → puede ir a Inactivo (2) o Congelado (3)
                        allowedTransitionValues = [2, 3];
                        break;
                    case 2: // Inactivo → puede ir a Activo (1) o Congelado (3)
                        allowedTransitionValues = [1, 3];
                        break;
                    case 3: // Congelado → puede ir a Activo (1) o Inactivo (2)
                        allowedTransitionValues = [1, 2];
                        break;
                    default:
                        allowedTransitionValues = []; // No hay transiciones disponibles
                }

                // BILL-2597: planes VARIABLE no admiten "Congelado" (value=3) en el dropdown.
                if (this.currentPlanType === PlanType.VARIABLE) {
                    allowedTransitionValues = allowedTransitionValues.filter(v => v !== 3);
                }

                // Filtrar solo los estatus de transición disponibles (sin incluir el actual)
                this.availableStatuses = this.estatus.filter(status =>
                    allowedTransitionValues.includes(status.value)
                );

                if (!this.isOnDemandPlan) {
                    this.form.controls['status_customerPlan'].enable();
                }
                // Mantener el valor actual como valor por defecto del formulario
                this.form.controls['status_customerPlan'].setValue(currentStatus);
            } else {
                // Si no es editable, deshabilitar el campo
                this.form.controls['status_customerPlan'].disable();
                this.availableStatuses = []; // No mostrar opciones en el dropdown
            }
        }
    }

    private canDeactivateFuturePendingSubscription(currentStatus: number): boolean {
        return this.PENDING_FUTURE_STATUSES.includes(currentStatus) &&
            !this.isOnDemandPlan &&
            this.isStartDateInFuture(this.chp?.startdate_customerPlan);
    }

    private isStartDateInFuture(value: any): boolean {
        const startDate = this.parseDateOnly(value);
        if (!startDate) {
            return false;
        }

        const today = new Date();
        today.setHours(0, 0, 0, 0);
        return startDate.getTime() > today.getTime();
    }

    private parseDateOnly(value: any): Date | null {
        if (!value) {
            return null;
        }

        if (value instanceof Date) {
            const date = new Date(value);
            date.setHours(0, 0, 0, 0);
            return date;
        }

        const dateText = String(value).trim().substring(0, 10);
        const parts = dateText.split('-').map(part => Number(part));
        if (parts.length !== 3 || parts.some(part => Number.isNaN(part))) {
            return null;
        }

        const date = new Date(parts[0], parts[1] - 1, parts[2]);
        date.setHours(0, 0, 0, 0);
        return date;
    }

    goBack() {
        this.location.back();
    }

    /**
     * BILL-2569: aplica reglas según el tipo del plan actual del chp.
     * - LINK_DE_PAGO (0): dropdown de planes deshabilitado.
     * - VARIABLE (2): muestra campos customAmount/customTaxRate pre-populados con los del chp.
     */
    private applyPlanTypeRules(): void {
        // BILL-2672: plan ON_DEMAND no permite cambios de plan ni de estatus
        if (this.isOnDemandPlan) {
            this.form.controls['plan'].disable();
            this.form.controls['status_customerPlan'].disable();
            this.showVariableFields = false;
            return;
        }

        // Plan LINK_DE_PAGO: no permitir cambiar de plan desde esta pantalla.
        if (this.currentPlanType === PlanType.LINK_DE_PAGO) {
            this.form.controls["plan"].disable();
        } else {
            this.form.controls["plan"].enable();
        }

        // Plan VARIABLE actual: pre-popular y habilitar validaciones requeridas.
        if (this.currentPlanType === PlanType.VARIABLE) {
            this.showVariableFields = true;
            this.form.controls["customAmount"].setValue(this.chp.customAmount);
            this.form.controls["customTaxRate"].setValue(this.chp.customTaxRate);
            this.setVariableValidators(true);
        } else {
            this.showVariableFields = false;
            this.setVariableValidators(false);
        }
    }

    /**
     * BILL-2569: handler del dropdown de planes. Aplica las reglas de transición
     * de tipo definidas en el ticket (NORMAL <-> VARIABLE muestra/oculta campos).
     */
    onPlanChange(newPlanId: any): void {
        const planObj = this.servicePlans.find(p => p.id == newPlanId);
        if (!planObj) {
            return;
        }

        // ON_DEMAND no debería aparecer (filtrado en carga), pero por defensa
        if (+planObj.type === PlanType.ON_DEMAND) {
            this.toast.showError("No se puede cambiar a un plan Bajo Demanda");
            this.form.controls['plan'].setValue(this.plan);
            return;
        }

        this.selectedPlanType = planObj.type;

        if (this.selectedPlanType === PlanType.VARIABLE) {
            this.showVariableFields = true;
            // Si ya veníamos de VARIABLE, mantenemos los valores existentes;
            // si veníamos de NORMAL/LINK_DE_PAGO, los dejamos vacíos como obligatorios.
            if (this.currentPlanType !== PlanType.VARIABLE) {
                this.form.controls["customAmount"].setValue("");
                this.form.controls["customTaxRate"].setValue("");
            }
            this.setVariableValidators(true);
        } else {
            this.showVariableFields = false;
            this.form.controls["customAmount"].setValue("");
            this.form.controls["customTaxRate"].setValue("");
            this.setVariableValidators(false);
        }
    }

    /**
     * BILL-2569: alterna validators required/min sobre los campos custom.
     */
    private setVariableValidators(active: boolean): void {
        const amount = this.form.controls["customAmount"];
        const tax = this.form.controls["customTaxRate"];
        if (active) {
            amount.setValidators([Validators.required, Validators.min(0.01)]);
            tax.setValidators([Validators.required, Validators.min(0)]);
        } else {
            amount.clearValidators();
            tax.clearValidators();
        }
        amount.updateValueAndValidity();
        tax.updateValueAndValidity();
    }

    update() {

        console.log("update");

        // BILL-2569: si el plan destino es VARIABLE, validar customAmount/customTaxRate.
        if (this.showVariableFields) {
            const amountCtrl = this.form.controls["customAmount"];
            const taxCtrl = this.form.controls["customTaxRate"];
            if (amountCtrl.invalid || taxCtrl.invalid) {
                amountCtrl.markAsTouched();
                taxCtrl.markAsTouched();
                this.toast.showError("Para planes variables, monto sin impuesto y porcentaje de impuesto son obligatorios.");
                return;
            }
        }

        let obj = this.form.value;
        this.chp = obj;
        let start = new Date(obj.startdate_customerPlan);
        let end = new Date(obj.endDate_customerPlan);
        if (obj.nextBill == null) {
            obj.nextBill = false;
        }
        // VALIDAMOS LAS FECHAS
        if (obj.endDate_customerPlan != null) {
            // Validar que la fecha de culminación no sea anterior al día actual
            const today = new Date();
            today.setHours(0, 0, 0, 0); // Ignorar la hora, solo comparar fechas
            const endDateOnly = new Date(end);
            endDateOnly.setHours(0, 0, 0, 0);
            
            if (endDateOnly < today) {
                this.toast.showError("La fecha de culminación no puede ser anterior al día actual.");
                return;
            }
        }
        
        if (obj.startdate_customerPlan != null && obj.endDate_customerPlan != null) { // SOLO VALIDAR SI AMBAS FECHAS SON DISTINTAS DE NULL
            if (end.getTime() <= start.getTime()) { // FECHA DE CULMINACION PREVIA A LA DE INSCRIPCIÓN
                this.toast.showError("Fecha de culminacion debe ser POSTERIOR a la fecha de inscripción");
                return;
            }
        }

        this.chp.service = {id: this.service};
        this.chp.customer = {id: this.customer.id};
        
        // Convert next_bill_date from Date object to string format
        if (this.chp.next_bill_date instanceof Date) {
            const localDate = new Date(this.chp.next_bill_date);
            localDate.setHours(12, 0, 0, 0); // evita desfase UTC
            this.chp.next_bill_date = this.datePipe.transform(localDate, 'yyyy-MM-dd');
        }
        
        // Convert endDate_customerPlan from Date object to string format
        if (this.chp.endDate_customerPlan instanceof Date) {
            const localEndDate = new Date(this.chp.endDate_customerPlan);
            localEndDate.setHours(12, 0, 0, 0); // evita desfase UTC
            this.chp.endDate_customerPlan = this.datePipe.transform(localEndDate, 'yyyy-MM-dd');
        }

        // Check if user is trying to change the end date when there are open invoices
        if (this.previousEndDate != this.chp.endDate_customerPlan) { // ESTA INTENTANDO CAMBIAR LA FECHA DE CULMINACION
            if (this.hasOpenInvoices) { // SI TIENE FACTURAS ABIERTAS PARA COBRO, RETORNAMOS ERROR Y NO DEJAMOS LA ACTUALIZACION
                this.toast.showError("No es posible actualizar la fecha de culminación mientras existan facturas en proceso de cobro.");
                return; // SALIMOS
            }
        }

        if (this.previousNextBillDate != this.chp.next_bill_date) { // ESTA INTENTANDO CAMBIAR LA PROXIMA FECHA DE COBRO
            // Validar que la nueva fecha de próximo cobro no sea anterior a hoy
            const today = new Date();
            today.setHours(0, 0, 0, 0); // Ignorar la hora, solo comparar fechas
            const nextBillDate = new Date(this.chp.next_bill_date);
            nextBillDate.setHours(0, 0, 0, 0);

            if (nextBillDate < today) {
                this.toast.showError("La fecha del próximo cobro no puede ser anterior al día de hoy.");
                return;
            }

            if (this.hasOpenInvoices) { // SI TIENE FACTURAS ABIERTAS PARA COBRO, RETORNAMOS ERROR Y NO DEJAMOS LA ACTUALIZACION
                this.toast.showError("Cambio de fecha no permitido: hay una factura activa en proceso de cobro. Intente nuevamente más tarde.");
                return; // SALIMOS
            } else if (this.hasInvoiceForCharge) {
                this.spinner.close();
                this.confirmService.confirm({
                    title: 'Confirmación',
                    message: "Al actualizar la fecha del próximo cobro, la factura actual en proceso será cerrada automáticamente. ¿Desea continuar?"
                })
                    .subscribe(res => {
                        if (!res) { // SI NO ESTA DEACUERDO ENTONCES SALIMOS
                            return;
                        } else {
                            this.continueUpdate()
                        }
                    })
            } else {
                this.continueUpdate()
            }
        } else {
            this.continueUpdate()
        }
    }

    continueUpdate() {
        this.spinner.open();
        if (this.chp.tdc != "") {
            console.log("if");
            const idx = this.lastarjetasa.findIndex((t: any) => t.id == this.chp.tdc);
            if (idx === -1) {
                this.toast.showError("No se encontró la tarjeta seleccionada");
                this.spinner.close();
                return;
            }
            const token = this.lastarjetasa[idx].token_creditCardToken;
            this.webService.get(this.webService.HOST + "/customer/" + this.customer.id + "/creditcard/token/" + token).subscribe(prm => {
                let card = prm['result'];
                // Se guarda el id de la tarjeta seleccionada
                this.chp.creditCardToken = {id: card.id};
                if (this.initialStatus != +this.chp.status_customerPlan) {
                    this.webService.put({action: +this.chp.status_customerPlan}, this.webService.HOST + "/ecommerce/hasplan/" + this.chp.id + "/status").subscribe(response => {
                        this.updateSuscription();
                    }, err => {
                        this.toast.showError(err);
                        this.spinner.close();
                        console.log(err);
                    });
                } else {
                    this.updateSuscription();
                }
            });
        } else {
            if (this.initialStatus != +this.chp.status_customerPlan) {
                this.webService.put({action: +this.chp.status_customerPlan}, this.webService.HOST + "/ecommerce/hasplan/" + this.chp.id + "/status").subscribe(response => {
                    this.updateSuscription();
                }, err => {
                    this.toast.showError(err);
                    this.spinner.close();
                    console.log(err);
                });
            } else {
                this.updateSuscription();
            }
        }
    }

    updateSuscription() {
        if (this.plan != +this.chp.plan) { // SE CAMBIÓ DE PLAN: CERRAR LAS FACTURAS DEL CLIENTE EN ESE PLAN
            this.spinner.close();
            // BILL-2569: usamos diálogo inline (mismo patrón que skipBillingDialog) en lugar
            // de AppConfirmService, que se veía desproporcionado.
            const dialogRef: MatDialogRef<any> = this.dialog.open(this.changePlanConfirmDialog);
            dialogRef.afterClosed().subscribe(res => {
                if (!res) {
                    return;
                }
                this.spinner.open();
                this.webService.put({action: 2}, this.webService.HOST + "/ecommerce/hasplan/" + this.chp.id + "/status?onboarding=true").subscribe(response => {
                    this.changePlan = true;
                    this.sendUpdate();
                }, err => {
                    // BILL-2569: si el backend bloquea por facturas comprometidas (409),
                    // mostramos modal con la lista en vez del toast genérico.
                    this.spinner.close();
                    if (this.isBlockingInvoicesError(err)) {
                        this.openBlockingInvoicesDialog(err);
                    } else {
                        this.toast.showError(err);
                    }
                });
            });

        } else {
            this.sendUpdate();
        }
    }

    /**
     * BILL-2569: detecta la respuesta 409 con código BILL_PLAN_CHANGE_BLOCKED_BY_INVOICES.
     */
    private isBlockingInvoicesError(err: any): boolean {
        if (!err) {
            return false;
        }
        const status = err.status || err?.error?.status;
        const code = err?.error?.code || err?.code;
        return status === 409 && code === 'BILL_PLAN_CHANGE_BLOCKED_BY_INVOICES';
    }

    /**
     * BILL-2569: abre el diálogo con la lista de facturas bloqueantes.
     */
    private openBlockingInvoicesDialog(err: any): void {
        this.blockingInvoices = (err?.error?.invoices || err?.invoices || []) as any[];
        this.dialog.open(this.blockingInvoicesDialog);
    }

    sendUpdate() {
        this.chp.plan = {id: this.chp.plan};
        if (this.form.controls['status_customerPlan'].disabled) {
            this.chp.status_customerPlan = this.initialStatus;
        }

        // BILL-2569: incluir customAmount/customTaxRate cuando el plan destino es VARIABLE.
        // Si no es VARIABLE, no enviamos esas claves (el backend las pondrá en NULL al cambiar de plan).
        if (this.selectedPlanType === PlanType.VARIABLE) {
            this.chp.customAmount = this.form.controls["customAmount"].value;
            this.chp.customTaxRate = this.form.controls["customTaxRate"].value;
        } else {
            delete this.chp.customAmount;
            delete this.chp.customTaxRate;
        }
        // console.log("ENVIANDO LA ACTUALIZACION ")
        // console.log(JSON.stringify({ hasplan: this.chp }, null, 2));
        // console.log(this.webService.HOST + "/hasplan/" + this.chp.id)
        this.webService.put({'hasplan': this.chp}, this.webService.HOST + "/hasplan/" + this.chp.id).subscribe(hasplan => {
            if (this.changePlan) { // SE CAMBIÓ EL PLAN: DAR DE ALTA LA SUSCRIPCIÓN
                this.webService.put({action: 1}, this.webService.HOST + "/ecommerce/hasplan/" + this.chp.id + "/status").subscribe(response => {
                    this.toast.showSuccess("Plan actualizado correctamente");
                    this.spinner.close();
                    this.location.back();
                }, err => {
                    this.toast.showError(err);
                    this.spinner.close();
                });
            } else {
                this.toast.showSuccess("Plan actualizado correctamente");
                this.spinner.close();
                this.location.back();
            }
        }, err => {
            this.spinner.close();
            this.toast.showError(err);
        });
    }

    /**
     * Abre el diálogo de confirmación para saltar la fecha de cobro.
     */
    openSkipBillingDialog(): void {
        const dialogRef: MatDialogRef<any> = this.dialog.open(this.skipBillingDialog);
        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.skipBillingDate();
            }
        });
    }

    /**
     * Realiza la solicitud HTTP PUT para saltar la fecha de cobro.
     */
    skipBillingDate(): void {
        this.spinner.open();
        const subscriptionId = this.chp.id; // Se asume que el ID de la suscripción se encuentra en this.chp.id
        const url = this.webService.HOST + `/subscriptions/${subscriptionId}/next-billing-date`;
        this.webService.put({}, url).subscribe(
            response => {
                this.toast.showSuccess("Fecha de cobro saltada correctamente");
                this.spinner.close();
                window.location.reload();
            },
            err => {
                this.toast.showError(err);
                this.spinner.close();
            }
        );
    }

    /** BILL-3747: indica si el usuario puede reactivar el cobro. */
    canReactivateBilling(): boolean {
        return this.userPermissionsService.hasPermission(REACTIVATE_BILLING_PERMISSION);
    }

    /**
     * BILL-3676: carga la factura reactivable de esta suscripción (si existe).
     * Falla en silencio: sin toast ni spinner.
     */
    loadReactivableInvoice(): void {
        if (!this.canReactivateBilling()) {
            this.reactivableInvoice = null;
            return;
        }
        this.invoiceReactivation.getReactivable(this.customer?.id).pipe(
            catchError(() => of([] as ReactivableInvoice[]))
        ).subscribe(list => {
            this.reactivableInvoice = (list || []).find(item => item.customerHasPlanId == this.chp?.id) || null;
        });
    }

    openReactivateDialog(): void {
        if (!this.reactivableInvoice || this.isReactivating || this.reactivateDialogRef) {
            return;
        }
        const dialogRef: MatDialogRef<any> = this.dialog.open(this.reactivateBillingDialog, {
            ariaLabelledBy: 'reactivate-dialog-title'
        });
        this.reactivateDialogRef = dialogRef;
        dialogRef.afterClosed().subscribe(result => {
            this.reactivateDialogRef = null;
            if (result) {
                this.reactivateBilling();
            }
        });
    }

    reactivateBilling(): void {
        if (this.isReactivating || !this.reactivableInvoice) {
            return;
        }
        const invoice = this.reactivableInvoice;
        this.isReactivating = true;
        this.spinner.open();
        this.invoiceReactivation.reactivate(invoice.invoiceId).pipe(
            finalize(() => {
                this.isReactivating = false;
                this.spinner.close();
            })
        ).subscribe({
            next: () => {
                this.reactivationDone = invoice;
                this.reactivableInvoice = null;
            },
            error: err => this.handleReactivationError(err)
        });
    }

    private handleReactivationError(err: any): void {
        switch (this.invoiceReactivation.extractConflictCode(err)) {
            case ReactivationConflictCode.ALREADY_REACTIVATED:
                this.reactivableInvoice = null;
                this.toast.showInfo(this.translate.instant('customerPlanUpdate.reactivate.errors.alreadyReactivated'));
                break;
            case ReactivationConflictCode.NOT_ELIGIBLE:
                this.toast.showError(this.translate.instant('customerPlanUpdate.reactivate.errors.notEligible'));
                this.loadReactivableInvoice();
                break;
            case ReactivationConflictCode.STATUS_CHANGED:
                this.toast.showError(this.translate.instant('customerPlanUpdate.reactivate.errors.statusChanged'));
                this.loadReactivableInvoice();
                break;
            default:
                this.toast.showError(this.translate.instant('customerPlanUpdate.reactivate.errors.generic'));
        }
    }
}
